export type ProductSliderOptions = {
  showInfoButton?: boolean;
  showAddToCartButton?: boolean;
  showBadges?: boolean;
  showColorSwatch?: boolean;
  isExtranet?: boolean;
  analyticsProductListName?: string;
};

export const defaultProductSliderOptions: ProductSliderOptions = {
  showInfoButton: false,
  showAddToCartButton: false,
  showBadges: true,
  showColorSwatch: false,
  isExtranet: false,
  analyticsProductListName: '',
};
